import * as amplitude from "@amplitude/analytics-browser";
type trackEventType = {
  eventName: string;
};
//initialise amplitude
export const initialiseAmplitude = () => {
  const apiKey: string = "d2795abc5aa50e0778db39810e9a3606";
  //   import.meta.env.AMPLITUDE_API_KEY;
  amplitude.init(apiKey);
};

//track event on amplitude
export const trackEvent = ({ eventName }: trackEventType) => {
  amplitude.track(eventName);
};

//set user for user based tracking
export const setUser = (userName: string) => {
  amplitude.setUserId(userName);
};
